import { render, staticRenderFns } from "./EditFlowInfoModal.vue?vue&type=template&id=06fae1b0"
import script from "./EditFlowInfoModal.vue?vue&type=script&lang=js"
export * from "./EditFlowInfoModal.vue?vue&type=script&lang=js"
import style0 from "./EditFlowInfoModal.vue?vue&type=style&index=0&id=06fae1b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports